import { render } from "./DataTableControl.vue?vue&type=template&id=923a9892&scoped=true"
import script from "./DataTableControl.vue?vue&type=script&lang=js"
export * from "./DataTableControl.vue?vue&type=script&lang=js"

import "./DataTableControl.vue?vue&type=style&index=0&id=923a9892&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-923a9892"]])

export default __exports__